// extracted by mini-css-extract-plugin
module.exports = {"no_focus":"styles__no_focus___2ORzT","custom_styles":"styles__custom_styles___BDGhK","day":"styles__day___24exe","eventLabel":"styles__eventLabel___2-8dQ"};